import script from "./softwareForm.vue?vue&type=script&setup=true&lang=js"
export * from "./softwareForm.vue?vue&type=script&setup=true&lang=js"

import "./softwareForm.vue?vue&type=style&index=0&id=311e5331&scoped=true&lang=css"

import exportComponent from "/var/www/upgrade-junction/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-311e5331"]])

export default __exports__